import { makeStyles } from '@mui/styles';
const textTooltipStyles = makeStyles(({ palette, spacing }) => ({
    tooltipArrow: {
        color: palette.primary.main,
    },
    tooltip: {
        border: '1.5px solid',
        borderColor: palette.primary.main,
        borderRadius: '10px',
        background: palette.common.white,
        padding: spacing(1.5),
        color: palette.common.black,
    },
    tooltipSvg: {},
}), { name: 'Common_TextTooltip' });
export default textTooltipStyles;
//# sourceMappingURL=textTooltip.styles.js.map